/* cart-drawer.js — Tasty Dose cart drawer runtime (window.TDCart).
 * Design, guards and the reasons behind them: CART-DRAWER.md and CART-ARCHITECTURE.md.
 * Debug: ?td_cart_debug=1. Size budget: keep the minified size under 25 KB (CART-QA.md tier 1). */
(function () {
  'use strict';
  if (window.TDCart) return;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var CART_RE = /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/;
  var GATE_ID = 'td-upsell-cart-gate';

  var state = {
    seq: 0,
    applied: 0,
    inflight: 0,
    adding: 0,
    pendingQty: {},
    addStarts: {},
    addQty: {},
    addBump: {},
    addInfo: {},
    products: {},
    rowTpl: null,
    lastTap: null,
    renderedCount: 0,
    qtyInFlight: false,
    refreshing: null,
    refreshAgain: false,
    dirty: false,
    lastHtml: '',
    money: null,
    applying: false,
    repairAt: 0,
    syncTimer: null,
    settle: false,
    settleTimer: null,
    idleWaiters: []
  };

  var stats = { lastOpenMs: null, lastAddMs: null, lastApplyMs: null, renders: 0, repairs: 0 };

  function debugOn() {
    try {
      return !!(window.TD_CART_DEBUG || /[?&]td_cart_debug=1\b/.test(location.search) || localStorage.getItem('td_cart_debug') === '1');
    } catch (e) { return !!window.TD_CART_DEBUG; }
  }
  function dlog() {
    if (!debugOn() || !window.console) return;
    console.log.apply(console, ['[td-cart]', '+' + Math.round(performance.now()) + 'ms'].concat([].slice.call(arguments)));
  }
  function warn() {
    if (window.console) console.warn.apply(console, ['[td-cart]'].concat([].slice.call(arguments)));
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function host() { return document.querySelector('cart-drawer'); }
  function inner() { var h = host(); return h ? h.querySelector('.drawer__inner') : null; }
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  function cssEsc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\\]]/g, '\\$&');
  }
  function toInt(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }
  function hasPendingQty() { for (var k in state.pendingQty) if (Object.prototype.hasOwnProperty.call(state.pendingQty, k)) return true; return false; }

  function isBusy() { return state.inflight > 0 || state.adding > 0 || state.qtyInFlight || hasPendingQty() || !!state.refreshing; }
  function hasUpcart() { return typeof window.upcartRefreshCart === 'function'; }

  // App discounts (EasyGift's free gifts) can be missing from the render a mutation returns,
  // so the gift showed full price until checkout. One quiet re-read after the cart settles
  // picks up the final prices; an identical render is a no-op in applySections.
  var SETTLE_MS = 1200;
  function scheduleSettle() {
    clearTimeout(state.settleTimer);
    state.settleTimer = setTimeout(function () {
      state.settleTimer = null;
      if (isBusy()) { state.settle = true; return; }
      dlog('settle refresh');
      refreshSections();
    }, SETTLE_MS);
  }

  function busy(delta) {
    state.inflight = Math.max(0, state.inflight + delta);
    if (delta > 0) { state.settle = true; clearTimeout(state.settleTimer); }
    var h = host();
    if (h) h.classList.toggle('is-busy', isBusy());
    if (!isBusy()) {
      var w = state.idleWaiters; state.idleWaiters = [];
      w.forEach(function (fn) { try { fn(); } catch (e) {} });
      if (state.dirty && !state.refreshing) { state.dirty = false; refreshSections(); }
      else if (state.settle) { state.settle = false; scheduleSettle(); }
    }
  }
  function whenIdle(maxMs) {
    return new Promise(function (resolve) {
      if (!isBusy()) return resolve();
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; resolve(); } }, maxMs || 3000);
      state.idleWaiters.push(function () { if (!done) { done = true; clearTimeout(t); resolve(); } });
    });
  }

  function parseProbe(s) {
    if (!s) return null;
    var m = String(s).match(/^(.*?)(\d[\d.,\s  ']*\d|\d)(.*)$/);
    if (!m) return null;
    var core = m[2];
    var digits = core.replace(/\D/g, '');
    var seps = core.replace(/\d/g, '');
    var out = { prefix: m[1], suffix: m[3], dec: 0, decSep: '', thouSep: '' };
    if (digits === '1234567') {
      out.dec = 2;
      out.decSep = core.charAt(core.length - 3);
      var first = seps.charAt(0);
      out.thouSep = (seps.length > 1 || (seps.length === 1 && first !== out.decSep)) ? first : '';
    } else if (digits === '12346' || digits === '12345') {
      out.dec = 0;
      out.thouSep = seps.charAt(0) || '';
    } else {
      return null;
    }
    return out;
  }
  function group(n, sep) {
    var s = String(n);
    return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s;
  }
  function fmtMoney(cents) {
    var f = state.money;
    if (!f) return null;
    var neg = cents < 0;
    cents = Math.abs(Math.round(cents));
    var s;
    if (f.dec === 2) {
      var r = cents % 100;
      s = group(Math.floor(cents / 100), f.thouSep) + f.decSep + (r < 10 ? '0' + r : String(r));
    } else {
      s = group(Math.round(cents / 100), f.thouSep);
    }
    return (neg ? '-' : '') + f.prefix + s + f.suffix;
  }
  function setMoney(el, cents) {
    if (!el) return;
    var s = fmtMoney(cents);
    if (s == null) { el.classList.add('is-pending'); return; }
    el.textContent = s;
  }
  function parseMoney(str) {
    var f = state.money;
    var d = String(str || '').replace(/\D/g, '');
    if (!f || !d) return null;
    return f.dec === 2 ? toInt(d) : toInt(d) * 100;
  }
  function readMoneyProbe() {
    var i = inner();
    state.money = i ? parseProbe(i.getAttribute('data-money-probe')) : null;
  }

  function countNow() {
    var i = inner();
    if (!i) return 0;
    var a = i.getAttribute('data-item-count');
    if (a != null && a !== '') return toInt(a);
    return i.querySelector('.td-cart-empty') ? 0 : 1;
  }
  function writeCount(n) {
    n = Math.max(0, n);
    var i = inner();
    if (i) i.setAttribute('data-item-count', String(n));
    var c = document.querySelector('cart-drawer .td-cart__count');
    if (c) c.textContent = '( ' + n + ' )';
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) {
      var bubble = icon.querySelector('.cart-count-bubble');
      if (n > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          bubble.innerHTML = '<span aria-hidden="true"></span>';
          icon.appendChild(bubble);
        }
        var span = bubble.querySelector('span[aria-hidden]');
        if (span) span.textContent = n < 100 ? String(n) : '';
      } else if (bubble) {
        bubble.remove();
      }
    }
  }
  function bumpCount(delta) { if (delta) writeCount(countNow() + delta); }

  function skeleton() {
    var d = document.createElement('div');
    d.className = 'td-cart-skel';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="td-cart-skel__img"></div>' +
      '<div class="td-cart-skel__body">' +
        '<div class="td-cart-skel__bar"></div>' +
        '<div class="td-cart-skel__bar td-cart-skel__bar--short"></div>' +
        '<div class="td-cart-skel__bar td-cart-skel__bar--price"></div>' +
      '</div>';
    return d;
  }
  // Shape of a single-variant add: { id, plain, upsell } or null for multi-item adds.
  // plain: no properties or plan, so it merges into an existing line. upsell: only the
  // drawer rail's _upsell_* tracking properties, so the line is still an ordinary product row.
  // Properties as Shopify compares them when merging an add into a line: blank values
  // dropped, key order ignored.
  function propSig(obj) {
    var keys = Object.keys(obj || {}).filter(function (k) { return obj[k] !== '' && obj[k] != null; }).sort();
    return JSON.stringify(keys.map(function (k) { return [k, String(obj[k])]; }));
  }
  // Shape of a single-variant add: { id, plain, upsell, sig, plan } or null for multi-item adds.
  // plain: no properties or plan. upsell: only the drawer rail's _upsell_* tracking
  // properties, so the line is still an ordinary product row. sig: see propSig.
  function addShape(body) {
    try {
      var id = null, n = 0, plan = false, props = {};
      var scan = function (v, k) {
        var m;
        if (/^items\[/.test(k)) n += 2;
        else if (k === 'id') { id = String(v); n++; }
        else if ((m = k.match(/^properties\[(.*)\]$/))) props[m[1]] = v;
        else if (k === 'selling_plan' && v) plan = true;
      };
      if ((typeof FormData !== 'undefined' && body instanceof FormData) || (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams)) body.forEach(scan);
      else if (typeof body === 'string') {
        var s = body.replace(/^\s+/, '');
        if (s.charAt(0) === '{') {
          var o = JSON.parse(s);
          var items = o.items || [o];
          if (items.length !== 1 || items[0].id == null) return null;
          id = String(items[0].id); n = 1;
          plan = !!items[0].selling_plan;
          props = items[0].properties || {};
        } else new URLSearchParams(s).forEach(scan);
      } else return null;
      if (n !== 1 || !id) return null;
      var keys = Object.keys(props).filter(function (k) { return props[k] !== '' && props[k] != null; });
      return {
        id: id,
        plan: plan,
        props: props,
        sig: propSig(props),
        plain: !plan && !keys.length,
        upsell: !plan && keys.every(function (k) { return /^_upsell/.test(k); })
      };
    } catch (e) { return null; }
  }

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function imgSrc(img) { return img ? (img.getAttribute('src') || '') : ''; }
  // Option values the drawer row prints: pack sizes ("3X") are left out, as in cart-drawer.liquid.
  function rowOpts(list) { return (list || []).filter(function (o) { return o && o !== 'Default Title' && !/^\s*\d/.test(o); }); }
  // The drawer row's image: variant image, else product image, at 300px (cart-drawer.liquid,
  // td-cart-item-image source 'variant'). Same URL, so the real row reuses the loaded image.
  function rowImg(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : ''; }

  var WAIT = 'wait';
  // What the shopper just added, described as the drawer will render it, so the pending row
  // looks exactly like the line that replaces it. Upsell cards carry everything; elsewhere the
  // product JSON is read (cached per handle). Returns info, WAIT (JSON on its way) or null.
  function describeAdd(seq, variantId) {
    var tap = state.lastTap && Date.now() - state.lastTap.t < 5000 ? state.lastTap.el : null;
    var card = tap && tap.closest && tap.closest('.td-cart-upsell__card');
    if (card) {
      var sel = card.querySelector('[data-cu-select]');
      var opt = sel && sel.options[sel.selectedIndex];
      var btn = card.querySelector('[data-cu-add]');
      var src = (opt && opt.getAttribute('data-cart-img')) || (btn && btn.getAttribute('data-cu-cart-img'));
      var price = parseMoney((opt && opt.getAttribute('data-price')) || txt(card.querySelector('.td-cart-upsell__price')));
      var cmp = parseMoney(opt ? opt.getAttribute('data-compare') : txt(card.querySelector('.td-cart-upsell__compare')));
      var title = txt(card.querySelector('.td-cart-upsell__title'));
      return title && price ? { img: src || imgSrc(card.querySelector('.td-cart-upsell__img')), title: title, opts: rowOpts(opt ? txt(opt).split(' / ') : []), price: price, cap: cmp && cmp > price ? cmp : price } : null;
    }
    // This product page's own product first; otherwise the product card that was clicked.
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var own = meta && meta.variants && meta.variants.some(function (x) { return String(x.id) === String(variantId); });
    var m = own ? location.pathname.match(/\/products\/([^/?#]+)/) : null;
    for (var el = tap, up = 0; !m && el && el !== document.body && up < 7; el = el.parentElement, up++) {
      if (el.closest && el.closest('cart-drawer')) return null;
      var link = el.querySelector && el.querySelector('a[href*="/products/"]');
      if (link) m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    }
    if (!m) return null;
    var handle = m[1];
    var fromJson = function (p) {
      var v = p && p.variants && p.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return null;
      var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      var pr = toInt(v.price), c = toInt(v.compare_at_price);
      return { img: rowImg(img), title: p.title, opts: p.variants.length > 1 ? rowOpts(v.options) : [], price: pr, cap: c > pr ? c : pr };
    };
    if (state.products[handle]) return fromJson(state.products[handle]);
    nativeFetch.call(window, root().replace(/\/$/, '') + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) {
        if (p) state.products[handle] = p;
        if (state.addInfo[seq] !== WAIT) return;
        var info = fromJson(p);
        if (info) { info.vid = String(variantId); state.addInfo[seq] = info; }
        else delete state.addInfo[seq];
        showPendingAdd(seq);
      });
    return WAIT;
  }

  // A pack (bundle) add from a page that rendered its cart preview (product-main pack
  // inputs: data-td-cart-preview). Title, image and price are what cart-drawer.liquid will
  // print; the "Show N items" count is the distinct picked flavours plus the pack's gifts,
  // as the drawer counts component rows.
  function describePack(variantId, props) {
    var el = document.querySelector('[data-td-cart-preview="' + cssEsc(variantId) + '"]');
    if (!el) return null;
    var price = toInt(el.getAttribute('data-td-cart-price')), c = toInt(el.getAttribute('data-td-cart-compare'));
    var title = el.getAttribute('data-td-cart-title') || '';
    if (!title || !price) return null;
    var seen = {}, n = 0;
    String((props && props._FlavorIds) || '').split(',').forEach(function (x) { x = x.trim(); if (x && !seen[x]) { seen[x] = 1; n++; } });
    n += toInt(el.getAttribute('data-td-cart-gifts'));
    return { img: el.getAttribute('data-td-cart-img') || '', title: title, opts: [], price: price, cap: c > price ? c : price, items: n };
  }
  // "Show N items" for a pending pack, in the drawer's words (data-pack-show / data-pack-items,
  // plural forms split by "|" exactly as cart-drawer.liquid picks them).
  function packToggle(n) {
    var i = inner();
    if (!n || !i) return null;
    var forms = (i.getAttribute('data-pack-items') || 'items').split('|');
    var w = forms[forms.length - 1];
    if (n === 1) w = forms[0];
    else if (forms.length === 3 && n >= 2 && n <= 4) w = forms[1];
    else if (forms.length === 4 && n === 2) w = forms[1];
    else if (forms.length === 4 && n >= 3 && n <= 4) w = forms[2];
    var b = document.createElement('span');
    b.className = 'td-bundle-toggle';
    var label = document.createElement('span');
    label.className = 'td-bundle-toggle__label';
    label.textContent = (i.getAttribute('data-pack-show') || 'Show') + ' ' + n + ' ' + w;
    b.appendChild(label);
    var tpl = document.getElementById('td-cart-caret-tpl');
    if (tpl) { var c = document.createElement('span'); c.className = 'td-bundle-toggle__caret'; c.innerHTML = tpl.innerHTML; b.appendChild(c); }
    return b;
  }

  // The pending line is a clone of a real drawer row (or one remembered from earlier this
  // session), filled with the added product, so markup and CSS are the drawer's own.
  function rowTemplate() {
    var h = host();
    var r = h && h.querySelector('tr.cart-item[data-line-plain]:not(.td-cart-pending-row)');
    if (r) { state.rowTpl = r.outerHTML; try { sessionStorage.setItem('td_cart_row_tpl', state.rowTpl); } catch (e) {} }
    if (!state.rowTpl) { try { state.rowTpl = sessionStorage.getItem('td_cart_row_tpl'); } catch (e) {} }
    if (!state.rowTpl) { var g = document.getElementById('td-cart-ghost-row'); if (g) return g.innerHTML.trim(); }
    return state.rowTpl || null;
  }
  // An empty cart has no items table; its markup carries one to put the first pending line in
  // (cart-drawer.liquid, #td-cart-ghost-table). The server render replaces it.
  function ghostTable(h) {
    var t = document.getElementById('td-cart-ghost-table');
    var wrap = h.querySelector('#CartDrawer-CartItems');
    if (!t || !t.content || !wrap) return null;
    var frag = t.content.cloneNode(true);
    var tb = frag.querySelector('tbody');
    wrap.insertBefore(frag, wrap.firstChild);
    return tb;
  }
  function pendingRow(info, qty) {
    var tpl = rowTemplate();
    if (!tpl) return null;
    var tb = document.createElement('tbody');
    tb.innerHTML = tpl;
    var row = tb.firstElementChild;
    if (!row) return null;
    qty = qty || 1;
    ['id', 'data-line-key', 'data-line-qty', 'data-variant-id', 'data-line-merge', 'data-line-plain', 'data-line-props', 'data-unit-price', 'data-unit-cap', 'data-unit-struck'].forEach(function (a) { row.removeAttribute(a); });
    row.querySelectorAll('[id], [data-index], [data-line-key]').forEach(function (e) { e.removeAttribute('id'); e.removeAttribute('data-index'); e.removeAttribute('data-line-key'); });
    row.querySelectorAll('a[href]').forEach(function (e) { e.removeAttribute('href'); });
    row.classList.add('td-cart-pending-row');
    row.setAttribute('aria-hidden', 'true');
    row.inert = true;
    var img = row.querySelector('.cart-item__image');
    if (img) { img.removeAttribute('srcset'); if (info.img) img.setAttribute('src', info.img); else img.removeAttribute('src'); }
    var name = row.querySelector('.cart-item__name');
    if (name) name.textContent = info.title;
    var details = row.querySelector('.cart-item__details');
    var dl = details && details.querySelector('dl');
    var optTpl = dl && dl.querySelector('.product-option');
    if (dl) dl.querySelectorAll('.product-option').forEach(function (o) { o.remove(); });
    if (info.opts.length && details) {
      if (!dl) { dl = document.createElement('dl'); details.appendChild(dl); }
      info.opts.forEach(function (o, i) {
        var d = optTpl ? optTpl.cloneNode(true) : document.createElement('div');
        if (!optTpl) { d.className = 'product-option'; d.innerHTML = '<dt></dt><dd></dd>'; }
        var dd = d.querySelector('dd');
        if (dd) dd.textContent = o + (i < info.opts.length - 1 ? ', ' : '');
        dl.appendChild(d);
      });
    }
    var tg = details && packToggle(info.items);
    if (tg) details.appendChild(tg);
    var input = row.querySelector('.quantity__input');
    if (input) { input.value = String(qty); input.setAttribute('value', String(qty)); }
    var wrap = row.querySelector('.cart-item__price-wrapper');
    if (wrap) {
      var fin = '<span class="price price--end">' + fmtMoney(info.price * qty) + '</span>';
      wrap.innerHTML = info.cap > info.price
        ? '<div class="cart-item__discounted-prices"><s class="cart-item__old-price price price--end">' + fmtMoney(info.cap * qty) + '</s>' + fin + '</div>'
        : fin;
    }
    return row;
  }
  // Fallback when no row exists to clone yet (first add into an empty cart this session).
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pendingCard(info, qty) {
    qty = qty || 1;
    var d = document.createElement('div');
    d.className = 'td-cart-pending';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="td-cart-pending__media">' + (info.img ? '<img src="' + esc(info.img) + '" alt="" width="100" height="100">' : '') + '</div>' +
      '<div class="td-cart-pending__details"><p class="td-cart-pending__name">' + esc(info.title) + '</p>' +
        (info.opts.length ? '<p class="td-cart-pending__sub">' + esc(info.opts.join(', ')) + '</p>' : '') + '<span data-pack-toggle></span></div>' +
      '<div class="td-cart-pending__qty"><span>&minus;</span><span>' + qty + '</span><span>+</span></div>' +
      '<div class="td-cart-pending__price">' +
        (info.cap > info.price ? '<s>' + esc(fmtMoney(info.cap * qty)) + '</s>' : '') +
        '<span>' + esc(fmtMoney(info.price * qty)) + '</span></div>';
    var slot = d.querySelector('[data-pack-toggle]'), tg = packToggle(info.items);
    if (tg) slot.parentNode.replaceChild(tg, slot); else slot.parentNode.removeChild(slot);
    return d;
  }
  // The line an add will merge into: same variant, same properties, no selling plan.
  function mergeRow(variantId, sig) {
    var h = host();
    if (!h || !variantId) return null;
    var rows = h.querySelectorAll('tr.cart-item[data-line-merge][data-variant-id="' + cssEsc(variantId) + '"]');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i], p = {};
      if (r.hidden || r.classList.contains('is-removing')) continue;
      try { p = JSON.parse(r.getAttribute('data-line-props') || '{}'); } catch (e) { continue; }
      if (propSig(p) === (sig || '[]')) return r;
    }
    return null;
  }
  // Shows an in-flight add on its row: quantity, line total, subtotal and free-shipping bar.
  // The header count is handled by the caller.
  function bumpRow(row, qty) {
    var next = toInt(row.getAttribute('data-line-qty')) + qty;
    row.setAttribute('data-line-qty', String(next));
    var input = row.querySelector('.quantity__input');
    if (input) input.value = String(next);
    applyDelta(row, qty, next, true);
  }
  function showPendingAdd(seq, again) {
    var h = host();
    var bump = state.addBump[seq];
    var row = bump && mergeRow(bump.id, bump.sig);
    if (row) { bumpRow(row, state.addQty[seq]); return; }
    var info = state.addInfo[seq];
    if (info === WAIT || !h) return;
    var el = null, tbody = h.querySelector('.cart-items tbody');
    if (info && info.price && state.money) {
      if (!tbody) tbody = ghostTable(h);
      el = tbody ? pendingRow(info, state.addQty[seq]) : null;
      if (el) tbody.insertBefore(el, tbody.firstChild);
      else el = pendingCard(info, state.addQty[seq]);
      shiftTotals(info.price, info.cap, state.addQty[seq]);
      h.classList.add('is-adding-merge');
    } else if (h.querySelector('tr.cart-item[data-line-key]')) {
      // A line the drawer cannot draw exactly (packs, bundles): reserve no space. The real
      // row opens in place when it lands (td-cart-row-in).
      return;
    } else el = skeleton();
    if (again) el.classList.add('is-static');
    if (!el.parentNode) { var wrap = h.querySelector('#CartDrawer-CartItems'); if (wrap) wrap.insertBefore(el, wrap.firstChild); }
  }
  function beginAdd(seq, qty, open, body) {
    var h = host();
    if (!h || hasUpcart()) return;
    state.adding++;
    state.addStarts[seq] = performance.now();
    state.addQty[seq] = qty || 1;
    if (countNow() === 0 && state.adding === 1) h.classList.add('is-adding-from-empty');
    h.classList.add('is-adding');
    var shape = addShape(body);
    if (shape && !shape.plan && mergeRow(shape.id, shape.sig)) state.addBump[seq] = { id: shape.id, sig: shape.sig };
    else if (shape && (shape.plain || shape.upsell)) {
      var info = describeAdd(seq, shape.id);
      if (info && info !== WAIT) info.vid = shape.id;
      if (info) state.addInfo[seq] = info;
    } else if (shape && !shape.plan) {
      var pack = describePack(shape.id, shape.props);
      if (pack) { pack.vid = shape.id; state.addInfo[seq] = pack; }
    }
    showPendingAdd(seq);
    if (state.addBump[seq]) h.classList.add('is-adding-merge');
    bumpCount(qty || 1);
    busy(0);
    syncState();
    if (open !== false) openDrawer();
    dlog('add #' + seq + ' started (qty ' + (qty || 1) + ')');
  }
  function endAdd(seq, ok) {
    var h = host();
    if (state.adding > 0) state.adding--;
    if (!ok) writeCount(state.renderedCount);
    if (!state.addStarts[seq]) { var ks = Object.keys(state.addStarts); if (ks.length) seq = ks[0]; }
    // A failed bump must be re-rendered even if the server markup did not change.
    if (state.addBump[seq] || state.addInfo[seq]) { if (!ok) state.lastHtml = ''; delete state.addBump[seq]; delete state.addInfo[seq]; }
    if (state.addStarts[seq]) { stats.lastAddMs = Math.round(performance.now() - state.addStarts[seq]); delete state.addStarts[seq]; delete state.addQty[seq]; dlog('add #' + seq + (ok ? ' ok' : ' FAILED') + ' in ' + stats.lastAddMs + 'ms'); }
    if (!h) return;
    if (state.adding === 0) {
      h.classList.remove('is-adding', 'is-adding-from-empty', 'is-adding-merge');
      h.querySelectorAll('.td-cart-skel, .td-cart-pending, .td-cart-pending-row, .td-cart-ghost').forEach(function (n) { n.remove(); });
      syncState();
    }
    busy(0);
  }

  function swapBubble(html) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    if (src) icon.innerHTML = src.innerHTML;
  }

  function applySections(sections, seq, opts) {
    opts = opts || {};
    if (!sections) return false;
    if (seq == null) seq = ++state.seq;
    if (seq < state.applied && !opts.force) { dlog('render #' + seq + ' is older than #' + state.applied + ', skipped'); return false; }
    var h = host();
    var html = sections['cart-drawer'];
    var t0 = performance.now();
    if (html && h) {
      if (hasPendingQty() && !opts.force) {

        dlog('render #' + seq + ' deferred: quantity edits pending');
        state.dirty = true;
      } else if (html !== state.lastHtml || opts.force) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = h.querySelector('#CartDrawer');
        var items = cur && cur.querySelector('cart-drawer-items');
        var scrollTop = items ? items.scrollTop : 0;
        var openKeys = [];
        if (cur) cur.querySelectorAll('[data-bundle-toggle][aria-expanded="true"]').forEach(function (b) { openKeys.push(b.getAttribute('data-bundle-toggle')); });
        var focusId = (document.activeElement && cur && cur.contains(document.activeElement)) ? document.activeElement.id : '';
        var errEl = cur && cur.querySelector('#CartDrawer-CartErrors');
        var errText = (errEl && errEl.classList.contains('is-visible')) ? errEl.textContent : '';
        var oldKeys = {};
        if (cur) cur.querySelectorAll('tr.cart-item[data-line-key]').forEach(function (r) { oldKeys[r.getAttribute('data-line-key')] = 1; });
        var pendingImg = {};
        Object.keys(state.addInfo).forEach(function (k) { var inf = state.addInfo[k]; if (inf && inf.img) pendingImg[inf.vid] = inf.img; });
        // The upsell rail's dots are rendered empty and filled by cart-upsell.js after a
        // debounce; carrying them (and the slider position) over stops the row collapsing
        // and the slider jumping back on every render.
        var oldRail = cur && cur.querySelector('[data-td-cart-upsell]');
        var oldDots = oldRail && oldRail.querySelector('[data-cu-dots]');
        var dotsHtml = oldDots && !oldDots.hidden ? oldDots.innerHTML : null;
        var oldGrid = oldRail && oldRail.querySelector('.td-cart-upsell__grid');
        var railScroll = oldGrid ? oldGrid.scrollLeft : 0;
        var railEntry = oldRail ? oldRail.getAttribute('data-cu-entry-handle') : null;
        var oldAcc = cur && cur.querySelector('.td-cart-acc__list');
        var accScroll = oldAcc ? oldAcc.scrollLeft : 0;
        var oldMask = cur && cur.querySelector('.td-cart-ship__mask');
        var oldMaskW = oldMask ? oldMask.style.width : '';
        state.applying = true;
        try {
          if (fresh && cur) {

            cur.innerHTML = fresh.innerHTML;
          } else {
            var nd = doc.querySelector('cart-drawer');
            if (nd) h.innerHTML = nd.innerHTML;
          }
        } finally { state.applying = false; }
        state.lastHtml = html;
        state.dirty = false;
        state.lastAppliedAt = Date.now();
        stats.renders++;
        var rail = h.querySelector('[data-td-cart-upsell]');
        if (rail && railEntry != null && rail.getAttribute('data-cu-entry-handle') === railEntry) {
          var dots = rail.querySelector('[data-cu-dots]');
          if (dots && dotsHtml != null) { dots.innerHTML = dotsHtml; dots.hidden = false; }
          var grid = rail.querySelector('.td-cart-upsell__grid');
          if (grid && railScroll) { try { grid.scrollTo({ left: railScroll, behavior: 'instant' }); } catch (e) { grid.scrollLeft = railScroll; } }
        }
        var acc = accScroll && h.querySelector('.td-cart-acc__list');
        if (acc) { try { acc.scrollTo({ left: accScroll, behavior: 'instant' }); } catch (e) { acc.scrollLeft = accScroll; } }
        var items2 = h.querySelector('cart-drawer-items');
        if (items2 && scrollTop) items2.scrollTop = scrollTop;
        if (errText) { var errEl2 = h.querySelector('#CartDrawer-CartErrors'); if (errEl2) { errEl2.textContent = errText; errEl2.classList.add('is-visible'); } }
        var pendingSeqs = [];
        if (state.adding > 0) {
          var pendingQty = 0, ks2 = Object.keys(state.addQty), skipped = false;
          for (var q = 0; q < ks2.length; q++) {
            if (opts.settlesAdd && !skipped && (ks2[q] === String(opts.settlesAdd) || !state.addQty[opts.settlesAdd])) { skipped = true; continue; }
            pendingQty += state.addQty[ks2[q]];
            pendingSeqs.push(ks2[q]);
          }
          if (pendingQty) writeCount(countNow() + pendingQty);
        }
        if (countNow() > 0) h.classList.remove('is-adding-from-empty');
        pendingSeqs.forEach(function (k) { showPendingAdd(k, true); });
        arrive(h, oldKeys, pendingImg, oldMaskW);
        openKeys.forEach(function (k) {
          var b = h.querySelector('[data-bundle-toggle="' + cssEsc(k) + '"]');
          if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
        });
        if (focusId) { var fe = document.getElementById(focusId); if (fe) { try { fe.focus({ preventScroll: true }); } catch (e) {} } }
      }
    }
    if (sections['cart-icon-bubble']) swapBubble(sections['cart-icon-bubble']);
    if (seq > state.applied) state.applied = seq;
    readMoneyProbe();
    state.renderedCount = countNow();
    syncState();
    stats.lastApplyMs = Math.round(performance.now() - t0);
    dlog('render #' + seq + ' applied in ' + stats.lastApplyMs + 'ms');
    emit('cart:updated', { source: 'td-cart', seq: seq });
    emit('tastydose:cart-updated', { source: 'td-cart', seq: seq });
    emit('td-cart:applied', { seq: seq });
    return true;
  }

  function refreshSections(seq, open) {
    if (state.refreshing) { state.refreshAgain = true; return state.refreshing; }
    var mySeq = seq != null ? seq : ++state.seq;
    var url = (root() + '?sections=' + SECTIONS).replace('//?', '/?');
    state.refreshing = nativeFetch.call(window, url, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        applySections(sections, mySeq);
        if (open) openDrawer();
      })
      .catch(function (e) { warn('refresh failed', e); })
      .then(function () {
        state.refreshing = null;
        if (state.refreshAgain) { state.refreshAgain = false; return refreshSections(); }
        busy(0);
      });
    busy(0);
    return state.refreshing;
  }

  function showError(body, fallback) {
    var msg = (body && (body.description || body.message)) || fallback || (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
    // Shopify's request-format errors ("updates parameter is invalid") mean nothing to a
    // shopper; the drawer re-syncs itself instead. Only actionable messages are shown.
    if (/parameter|invalid/i.test(msg)) { warn('cart error not shown: ' + msg); return; }
    var el = document.getElementById('CartDrawer-CartErrors');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(state.errTimer);
    state.errTimer = setTimeout(function () { el.textContent = ''; el.classList.remove('is-visible'); }, 6000);
  }

  function syncState() {
    var h = host();
    var i = inner();
    if (!h || !i) return;
    var n = countNow();
    var adding = state.adding > 0;
    var wantEmpty = n === 0 && !adding;
    if (h.classList.contains('is-empty') !== wantEmpty) h.classList.toggle('is-empty', wantEmpty);
    if (h.classList.contains('is-busy') !== isBusy()) h.classList.toggle('is-busy', isBusy());
    var co = h.querySelector('#CartDrawer-Checkout');
    if (co && co.disabled !== (n === 0)) co.disabled = n === 0;
    if (adding || state.applying || isBusy()) return;
    var bad = null;
    if (n > 0 && (!co || !h.querySelector('.cart-items'))) bad = 'items=' + n + ' but no checkout/rows';
    else if (n === 0 && !h.querySelector('.td-cart-empty')) bad = 'items=0 but no empty block';
    if (bad) repair(bad);
  }
  function scheduleSync() {
    if (state.syncTimer) return;
    state.syncTimer = setTimeout(function () { state.syncTimer = null; syncState(); }, 20);
  }
  function repair(reason) {
    var now = Date.now();
    if (now - state.repairAt < 2000) return;
    state.repairAt = now;
    stats.repairs++;
    warn('invariant violated (' + reason + '); re-rendering from server');
    emit('td-cart:repair', { reason: reason });
    refreshSections();
  }

  function watchGate() {
    clearTimeout(state.gateTimer);
    state.gateTimer = setTimeout(function () {
      var gate = document.getElementById(GATE_ID);
      if (!gate) return;
      var popupOpen = document.querySelector('#td-upsell-popup-overlay.is-open:not([hidden]), #td-upsell-popup-modal.is-open:not([hidden])');
      if (popupOpen) { watchGate(); return; }
      gate.parentNode.removeChild(gate);
      warn('upsell cart gate released by watchdog (popup never showed)');
    }, 8000);
  }

  function openDrawer(triggeredBy) {
    var h = host();
    if (!h) return;
    if (typeof h.open === 'function') h.open(triggeredBy);
    else h.classList.add('animate', 'active');
  }
  function closeDrawer() {
    var h = host();
    if (h && typeof h.close === 'function') h.close();
  }

  function rowByKey(key) {
    var h = host();
    return h ? h.querySelector('tr.cart-item[data-line-key="' + cssEsc(key) + '"]') : null;
  }
  // Makes a server render land softly: a line that was shown as a pending card keeps
  // that card's image behind it until its own loads; a line nobody saw coming fades in;
  // the free-shipping bar slides to its new width instead of jumping.
  function arrive(h, oldKeys, pendingImg, oldMaskW) {
    h.querySelectorAll('tr.cart-item[data-line-key]:not([data-bundle-child])').forEach(function (r) {
      if (oldKeys[r.getAttribute('data-line-key')]) return;
      var src = pendingImg[r.getAttribute('data-variant-id')];
      var img = r.querySelector('.cart-item__image');
      if (src && img && !img.complete) img.style.background = 'center / cover no-repeat url("' + src.replace(/"/g, '%22') + '")';
      else if (!src) {
        r.classList.add('td-cart-row-in');
        r.addEventListener('animationend', function () { r.classList.remove('td-cart-row-in'); }, { once: true });
      }
    });
    var mask = h.querySelector('.td-cart-ship__mask');
    if (mask && oldMaskW && mask.style.width !== oldMaskW) {
      var w = mask.style.width;
      mask.style.width = oldMaskW;
      void mask.offsetWidth;
      mask.style.width = w;
    }
  }
  function shiftTotals(unit, cap, delta) {
    var h = host();
    var i = inner();
    if (!h || !i || !delta) return;
    var sub = toInt(i.getAttribute('data-subtotal')) + unit * delta;
    var cmp = toInt(i.getAttribute('data-compare-total')) + cap * delta;
    i.setAttribute('data-subtotal', String(sub));
    i.setAttribute('data-compare-total', String(cmp));
    setMoney(h.querySelector('.totals__total-value'), sub);
    var sav = cmp - sub;
    var badge = h.querySelector('.td-cart__savings');
    var cmpEl = h.querySelector('.td-cart__subtotal-compare');
    var show = cmp > 0 && sav > 0;
    if (badge) {
      badge.hidden = !show;
      if (show) {
        var tpl = badge.getAttribute('data-off-template') || '{n}% OFF';
        badge.textContent = tpl.replace('{n}', String(Math.round(sav * 100 / cmp)));
      }
    }
    if (cmpEl) { cmpEl.hidden = !show; if (show) setMoney(cmpEl, cmp); }

    var ship = h.querySelector('.td-cart-ship');
    if (ship) {
      var th = toInt(ship.getAttribute('data-ship-threshold'));
      if (th > 0) {
        var remaining = th - sub;
        var away = ship.querySelector('[data-ship-away]');
        var reached = ship.querySelector('[data-ship-reached]');
        if (away) away.hidden = remaining <= 0;
        if (reached) reached.hidden = remaining > 0;
        var amt = ship.querySelector('.td-cart-ship__amount');
        if (amt && remaining > 0) setMoney(amt, remaining);
        var mask = ship.querySelector('.td-cart-ship__mask');
        if (mask) mask.style.width = Math.max(0, Math.min(100, 100 - (sub * 100 / th))) + '%';
      }
    }
  }
  function applyDelta(row, delta, qty, keepCount) {
    if (!delta) return;
    var h = host();
    var i = inner();
    if (!h || !i) return;
    var unit = toInt(row.getAttribute('data-unit-price'));
    var cap = toInt(row.getAttribute('data-unit-cap'));
    var struck = toInt(row.getAttribute('data-unit-struck'));

    var totals = row.querySelector('.cart-item__totals');
    if (totals) {
      var fin = totals.querySelector('.price--end:not(.cart-item__old-price)');
      setMoney(fin, unit * qty);
      var old = totals.querySelector('.cart-item__old-price');
      if (old && struck) setMoney(old, struck * qty);
    }
    if (!keepCount) bumpCount(delta);
    shiftTotals(unit, cap, delta);
  }

  // Upsell products (tag "upsell", data-upsell-only) cannot be bought alone. When the last
  // main product goes, they go in the same request, so the cart is never upsell-only and
  // upsell-blocker.js has nothing to clean up after the fact.
  function orphanedUpsells() {
    var h = host();
    if (!h) return [];
    var main = false, ups = [];
    h.querySelectorAll('tr.cart-item[data-line-key]:not([data-bundle-child])').forEach(function (r) {
      if (r.hidden || r.classList.contains('is-removing') || r.classList.contains('td-bundle-gift')) return;
      if (r.hasAttribute('data-upsell-only')) ups.push(r.getAttribute('data-line-key'));
      else main = true;
    });
    return main ? [] : ups;
  }
  function setQty(key, qty, batch) {
    qty = Math.max(0, toInt(qty));
    var row = rowByKey(key);
    if (!row) return;
    // A second trash click while the row fades out would send a removal for a line that is
    // already gone, which Shopify refuses ("updates parameter is invalid").
    if (qty === 0 && row.classList.contains('is-removing')) return;
    var old = toInt(row.getAttribute('data-line-qty'));
    var delta = qty - old;
    row.setAttribute('data-line-qty', String(qty));
    var input = row.querySelector('.quantity__input');
    if (input && String(input.value) !== String(qty)) input.value = String(qty);
    var h0 = host();
    var rows = [row];
    if (h0) h0.querySelectorAll('tr.cart-item[data-bundle-child="' + cssEsc(key) + '"]').forEach(function (c) { rows.push(c); });
    if (qty === 0) {
      rows.forEach(function (r) { r.classList.add('is-removing'); });

      setTimeout(function () { rows.forEach(function (r) { if (r.classList.contains('is-removing')) r.hidden = true; }); }, 200);
    } else {
      rows.forEach(function (r) { r.classList.remove('is-removing'); r.hidden = false; });
    }
    applyDelta(row, delta, qty);
    state.pendingQty[key] = qty;
    if (batch) return;
    if (qty === 0) orphanedUpsells().forEach(function (k) { setQty(k, 0, true); });
    var hh = host();
    if (hh) hh.classList.add('is-busy');
    sendQty();
  }

  function sendQty() {
    if (state.qtyInFlight || !hasPendingQty()) return;
    var updates = state.pendingQty;
    state.pendingQty = {};
    state.qtyInFlight = true;
    var seq = ++state.seq;
    var t0 = performance.now();
    dlog('qty #' + seq + ' sending', updates);
    window.fetch(root().replace(/\/$/, '') + '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTIONS, sections_url: window.location.pathname }),
      __tdOwn: true
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (body) {
          state.qtyInFlight = false;
          dlog('qty #' + seq + ' answered in ' + Math.round(performance.now() - t0) + 'ms');
          if (!r.ok || !body || body.status) {
            // A key that no longer exists (line already removed, a gift swapped by an app):
            // re-sync once, then re-apply only the changes that still differ, without an error.
            var stale = /updates/i.test((body && (body.description || body.message)) || '') && !state.qtyRetried;
            if (!stale) showError(body);
            state.qtyRetried = stale;
            var p = refreshSections(seq);
            if (stale && p) p.then(function () {
              Object.keys(updates).forEach(function (k) {
                var row = rowByKey(k);
                if (row && toInt(row.getAttribute('data-line-qty')) !== updates[k]) setQty(k, updates[k]);
              });
            });
          } else if (body.sections && body.sections['cart-drawer']) {
            state.qtyRetried = false;
            applySections(body.sections, seq);
          } else {
            refreshSections(seq);
          }
        });
      })
      .catch(function (e) {
        state.qtyInFlight = false;
        warn('qty update failed', e);
        showError(null);
        refreshSections(seq);
      })
      .then(function () {
        if (hasPendingQty()) sendQty();
        else busy(0);
      });
  }

  function buildAddRequest(input) {
    var qty = 1;
    if (typeof FormData !== 'undefined' && input instanceof FormData) {
      if (!input.has('sections')) { input.append('sections', SECTIONS); input.append('sections_url', window.location.pathname); }
      qty = qtyOfForm(input);
      return { body: input, headers: { Accept: 'application/json' }, qty: qty };
    }
    var payload;
    if (input && input.items) payload = { items: input.items };
    else if (input && (input.id || input.quantity || input.properties)) {
      payload = { items: [{ id: Number(input.id), quantity: Number(input.quantity) || 1, properties: input.properties || undefined }] };
    } else payload = { items: [] };
    payload.sections = SECTIONS;
    payload.sections_url = window.location.pathname;
    qty = payload.items.reduce(function (s, it) { return s + (Number(it.quantity) || 1); }, 0) || 1;
    return { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, qty: qty };
  }
  function qtyOfForm(fd) {
    var q = 0;
    try { fd.forEach(function (v, k) { if (/(^|\[)quantity(\]|$)/.test(k)) q += Number(v) || 0; }); } catch (e) {}
    return q || 1;
  }
  function qtyOfBody(body) {
    try {
      if (!body) return 1;
      if (typeof FormData !== 'undefined' && body instanceof FormData) return qtyOfForm(body);
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return qtyOfForm(body);
      if (typeof body === 'string') {
        var s = body.replace(/^\s+/, '');
        if (s.charAt(0) === '{') {
          var o = JSON.parse(s);
          if (o.items) return o.items.reduce(function (t, it) { return t + (Number(it.quantity) || 1); }, 0) || 1;
          return Number(o.quantity) || 1;
        }
        var m = s.match(/(?:^|&)quantity=(\d+)/);
        return m ? Number(m[1]) || 1 : 1;
      }
    } catch (e) {}
    return 1;
  }

  function injectSections(body) {
    if (body == null) return { body: body, changed: false, has: false };
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.has('sections')) return { body: body, changed: false, has: true };
      body.append('sections', SECTIONS); body.append('sections_url', window.location.pathname);
      return { body: body, changed: false, has: true };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (body.has('sections')) return { body: body, changed: false, has: true };
      body.append('sections', SECTIONS); body.append('sections_url', window.location.pathname);
      return { body: body, changed: false, has: true };
    }
    if (typeof body === 'string') {
      var s = body.replace(/^\s+/, '');
      if (s.charAt(0) === '{') {
        var o = JSON.parse(s);
        if (o.sections) return { body: body, changed: false, has: true };
        o.sections = SECTIONS; o.sections_url = window.location.pathname;
        return { body: JSON.stringify(o), changed: true, has: true };
      }
      if (/(^|&)sections=/.test(s)) return { body: body, changed: false, has: true };
      if (/=/.test(s)) return { body: body + '&sections=' + encodeURIComponent(SECTIONS) + '&sections_url=' + encodeURIComponent(window.location.pathname), changed: true, has: true };
    }
    return { body: body, changed: false, has: false };
  }

  function add(input, opts) {
    opts = opts || {};
    var req;
    try { req = buildAddRequest(input); } catch (e) { return Promise.reject(e); }
    var seq = ++state.seq;
    if (opts.open !== false) beginAdd(seq, req.qty, true, req.body);
    return window.fetch(root().replace(/\/$/, '') + '/cart/add.js', { method: 'POST', headers: req.headers, body: req.body, __tdOwn: true })
      .then(function (res) {
        return res.json().catch(function () { return null; }).then(function (body) {
          if (!res.ok || (body && body.status && !body.items && !body.id)) {
            var msg = (body && (body.description || body.message)) || 'Cart add failed';
            var err = new Error(msg);
            err.serverMessage = msg; err.status = res.status; err.cartBody = body;
            throw err;
          }
          if (body && body.sections && body.sections['cart-drawer']) applySections(body.sections, seq, opts.open !== false ? { settlesAdd: seq } : {});
          else refreshSections(seq);
          if (opts.open !== false) { endAdd(seq, true); openDrawer(); }
          return body;
        });
      })
      .catch(function (err) {
        if (opts.open !== false) endAdd(seq, false);
        showError(err && err.cartBody, err && err.serverMessage);
        refreshSections(seq);
        throw err;
      });
  }

  var nativeFetch = window.fetch;
  function kindOf(url) {
    if (typeof url !== 'string') return null;
    var m = url.match(CART_RE);
    return m ? m[1] : null;
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var kind = kindOf(url);
    if (!kind) return nativeFetch.apply(this, arguments);
    var own = !!(init && init.__tdOwn);
    var seen = !!(init && init.__tdSeen);
    if (init) { try { init.__tdInner = true; } catch (e) {} }
    var seq = ++state.seq;
    dlog('fetch hook: ' + kind + (own ? ' (own)' : '') + (seen ? ' (seen)' : '') + ' #' + seq);
    var hasSections = own;
    if (!own && kind !== 'clear' && init && init.body !== undefined) {
      try {
        var r = injectSections(init.body);
        if (r.changed) init = Object.assign({}, init, { body: r.body });
        hasSections = r.has;
      } catch (e) {}
    }
    if (!own && !seen && kind === 'add' && !window.__tdCartQuiet) beginAdd(seq, qtyOfBody(init && init.body), true, init && init.body);
    busy(1);
    var p = nativeFetch.call(this, input, init);
    p.then(function (res) {
      busy(-1);
      if (own) return;
      if (!res.ok) {
        if (kind === 'add') endAdd(seq, false);
        res.clone().json().catch(function () { return null; }).then(function (b) { if (kind === 'add') showError(b); refreshSections(seq); });
        return;
      }
      res.clone().json().catch(function () { return null; }).then(function (body) {
        if (body && body.sections && body.sections['cart-drawer']) applySections(body.sections, seq, kind === 'add' ? { settlesAdd: seq } : {});
        else refreshSections(seq);
        if (kind === 'add') endAdd(seq, true);
      });
    }, function () {
      busy(-1);
      if (own) return;
      if (kind === 'add') { endAdd(seq, false); showError(null); }
      refreshSections(seq);
    });
    return p;
  };

  function installSentinel() {
    var cur = window.fetch;
    if (!cur || cur.__tdSentinel) return;
    var sentinel = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (kindOf(url) !== 'add' || (init && (init.__tdOwn || init.__tdSeen)) || window.__tdCartQuiet) {
        return cur.apply(this, arguments);
      }
      var marked = Object.assign({}, init || {}, { __tdSeen: true });
      var seq = ++state.seq;
      dlog('sentinel: add #' + seq);
      beginAdd(seq, qtyOfBody(marked.body), true, marked.body);
      var p = cur.call(this, input, marked);
      p.then(function (res) {
        if (marked.__tdInner) return;
        warn('add #' + seq + ' never reached the drawer hook; recovering');
        endAdd(seq, !!(res && res.ok));
        refreshSections(seq);
      }, function () {
        if (marked.__tdInner) return;
        endAdd(seq, false);
        refreshSections(seq);
      });
      return p;
    };
    sentinel.__tdSentinel = true;
    window.fetch = sentinel;
  }
  if (document.readyState === 'complete') { installSentinel(); setTimeout(installSentinel, 3000); }
  else window.addEventListener('load', function () { installSentinel(); setTimeout(installSentinel, 3000); });

  ['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { state.lastTap = { el: e.target, t: Date.now() }; installSentinel(); }, { capture: true, passive: true });
  });

  if (typeof XMLHttpRequest !== 'undefined') {
    var xo = XMLHttpRequest.prototype.open;
    var xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__tdCartKind = kindOf(String(url)); } catch (e) { this.__tdCartKind = null; }
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var kind = this.__tdCartKind;
      if (kind) {
        var seq = ++state.seq;
        var xhr = this;
        if (kind === 'add' && !window.__tdCartQuiet) beginAdd(seq, qtyOfBody(body), true, body);
        busy(1);
        xhr.addEventListener('loadend', function () {
          busy(-1);
          var ok = xhr.status >= 200 && xhr.status < 300;
          if (ok) {
            try {
              var b = JSON.parse(xhr.responseText);
              if (b && b.sections && b.sections['cart-drawer']) { applySections(b.sections, seq, kind === 'add' ? { settlesAdd: seq } : {}); if (kind === 'add') endAdd(seq, true); return; }
            } catch (e) {}
          } else {
            if (kind === 'add') { try { showError(JSON.parse(xhr.responseText)); } catch (e) { showError(null); } }
          }
          refreshSections(seq);
          if (kind === 'add') endAdd(seq, ok);
        });
      }
      return xs.apply(this, arguments);
    };
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('keyup', function (evt) { if (evt.code === 'Escape') this.close(); }.bind(this));
        this.setHeaderCartIconAccessibility();
      }
      connectedCallback() {
        if (this.__tdInit) return;
        this.__tdInit = true;
        var self = this;
        new MutationObserver(function () { if (!state.applying) scheduleSync(); })
          .observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        readMoneyProbe();
        state.lastHtml = '';
        state.renderedCount = countNow();
        syncState();
      }
      setHeaderCartIconAccessibility() {
        var cartLink = document.querySelector('#cart-icon-bubble');
        if (!cartLink || cartLink.__tdBound) return;
        cartLink.__tdBound = true;
        var self = this;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', function (event) { event.preventDefault(); self.open(cartLink); });
        cartLink.addEventListener('keydown', function (event) {
          if (event.code && event.code.toUpperCase() === 'SPACE') { event.preventDefault(); self.open(cartLink); }
        });
      }
      open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        var self = this;
        var wasActive = this.classList.contains('active');
        var t0 = performance.now();
        syncState();

        setTimeout(function () { self.classList.add('animate', 'active'); });
        if (!wasActive) {
          this.addEventListener('transitionend', function () {
            var container = self.classList.contains('is-empty') ? (self.querySelector('.drawer__inner-empty') || document.getElementById('CartDrawer')) : document.getElementById('CartDrawer');
            var focusEl = self.querySelector('.drawer__inner') || self.querySelector('.drawer__close');
            if (typeof trapFocus === 'function' && container && focusEl) { try { trapFocus(container, focusEl); } catch (e) {} }
            stats.lastOpenMs = Math.round(performance.now() - t0);
          }, { once: true });
          emit('td-cart:open', {});
          dlog('open');
        }
        document.body.classList.add('overflow-hidden');
        watchGate();
      }
      close() {
        this.classList.remove('active');
        if (typeof removeTrapFocus === 'function') { try { removeTrapFocus(this.activeElement); } catch (e) {} }
        document.body.classList.remove('overflow-hidden');
        emit('td-cart:close', {});
      }

      renderContents(parsedState) {
        if (parsedState && parsedState.sections) applySections(parsedState.sections, ++state.seq);
        else refreshSections();
        this.open();
      }
      getSectionsToRender() {
        return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
      }
      getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section').innerHTML;
      }
      setActiveElement(element) { this.activeElement = element; }
    });
  }

  if (!customElements.get('cart-drawer-items')) {
    customElements.define('cart-drawer-items', class CartDrawerItems extends HTMLElement {
      constructor() {
        super();
        var self = this;

        this.addEventListener('click', function (e) {
          var btn = e.target.closest ? e.target.closest('.quantity__button') : null;
          if (!btn || !self.contains(btn)) return;
          var row = btn.closest('tr.cart-item');
          var input = row && row.querySelector('.quantity__input');
          if (!row || !input || !row.getAttribute('data-line-key')) return;
          e.preventDefault();
          e.stopPropagation();
          if (btn.disabled) return;
          var step = Math.max(1, toInt(input.step) || 1);
          var cur = toInt(input.value);
          var next = btn.name === 'plus' ? cur + step : cur - step;
          var max = input.max ? toInt(input.max) : 0;
          if (max && next > max) next = max;
          if (next < 0) next = 0;
          if (next === cur) return;
          setQty(row.getAttribute('data-line-key'), next);
        }, true);

        this.addEventListener('change', function (e) {
          var input = e.target;
          if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
          var row = input.closest('tr.cart-item');
          if (!row || !row.getAttribute('data-line-key')) return;
          e.stopPropagation();
          clearTimeout(input.__tdTimer);
          input.__tdTimer = setTimeout(function () {
            var v = toInt(input.value);
            if (v < 0) v = 0;
            var max = input.max ? toInt(input.max) : 0;
            if (max && v > max) v = max;
            setQty(row.getAttribute('data-line-key'), v);
          }, 350);
        });
      }

      updateQuantity(line, quantity) {
        var row = document.getElementById('CartDrawer-Item-' + line);
        var key = row && row.getAttribute('data-line-key');
        if (key) setQty(key, quantity);
        else refreshSections();
      }
      onCartUpdate() { return refreshSections(); }
      getSectionsToRender() {
        return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
      }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.id === 'CartDrawer-Overlay') { closeDrawer(); return; }
    var closeBtn = t.closest('cart-drawer .drawer__close');
    if (closeBtn) { e.preventDefault(); closeDrawer(); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!btn || btn.__tdReclick || !isBusy()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.classList.add('is-waiting');
    dlog('checkout click held until the cart settles');
    whenIdle(3000).then(function () {
      btn.classList.remove('is-waiting');
      btn.__tdReclick = true;
      try { btn.click(); } finally { btn.__tdReclick = false; }
    });
  }, true);

  var extTimer = null;
  document.addEventListener('tastydose:cart-updated', function (e) {
    if (e && e.detail && e.detail.source === 'td-cart') return;
    clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      if (Date.now() - (state.lastAppliedAt || 0) < 600 || isBusy()) return;
      dlog('external cart change announced; re-rendering');
      refreshSections();
    }, 300);
  });

  window.TDCart = {
    open: openDrawer,
    close: closeDrawer,
    add: add,
    setQuantity: setQty,
    remove: function (key) { setQty(key, 0); },
    refresh: function (opts) { opts = opts || {}; return refreshSections(null, !!opts.open); },
    applySections: function (sections, opts) { return applySections(sections, null, opts); },
    whenIdle: whenIdle,
    isBusy: isBusy,
    count: countNow,
    stats: stats,
    _state: state
  };
})();
